<template>
    <div>
        <vx-card title="Job History" subtitle="Lists of Job Histories"  class="no-scroll-content" >


        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <vs-button type="gradient" color="primary" @click="promptAddNewJobHistory()"  icon-pack="feather" icon="icon-plus">Add</vs-button>

        <div class="vx-col w-full mb-base">
            <template>
                <vs-table stripe v-model="selected"  search  :data="employeeJobHistory">
                    <template slot="thead">
                        <vs-th>Company Name</vs-th>
                        <vs-th>Address</vs-th>
                        <vs-th>Last Job Title</vs-th>
                        <vs-th>From</vs-th>
                        <vs-th>To</vs-th>
                        <vs-th>Last Salary</vs-th>
                        <vs-th>Superior Name</vs-th>
                        <vs-th>Reason For Leave</vs-th>
                        <vs-th>Remarks</vs-th>
                        <vs-th>Action</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].companyName">
                                {{ data[indextr].companyName }}
                            </vs-td>
                            <vs-td :data="data[indextr].companyAddress">
                                {{ data[indextr].companyAddress }}
                            </vs-td>
                            <vs-td :data="data[indextr].lastJobTitle">
                                {{ data[indextr].lastJobTitle }}
                            </vs-td>
                            <vs-td :data="data[indextr].fromDate">
                                {{data[indextr].fromDate | fulldate}}
                            </vs-td>
                            <vs-td :data="data[indextr].toDate">
                                {{data[indextr].toDate | fulldate}}
                            </vs-td>
                            <vs-td :data="data[indextr].lastSalary">
                                {{data[indextr].lastSalary}}
                            </vs-td>
                            <vs-td :data="data[indextr].superiorName">
                                {{ data[indextr].superiorName }}
                            </vs-td>
                            <vs-td :data="data[indextr].reasonforLeaving">
                                {{ data[indextr].reasonforLeaving }}
                            </vs-td>
                            <vs-td :data="data[indextr].remarks">
                                {{ data[indextr].remarks }}
                            </vs-td>
                            <vs-td>
                                <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].id)" />
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </template>
             
        </div>

            <!-- ADD ACCREDITATION -->
            <vs-prompt
                class="email-compose"
                title="Job History"
                accept-text= "Submit"
                @accept="onAddJobHistory"
                :is-valid="validForm"
                :active.sync="activePromptNewJobHistory">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Company Name</span><span style="color:red">*</span>
                        <vs-input v-validate="'alpha_spaces|max:50'" name="company name" class="w-full" v-model="companyName" placeholder="Company Name" />
                        <span class="text-danger text-sm" v-show="errors.has('company name')">{{ errors.first('company name') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Company Address</span><span style="color:red">*</span>
                         <vs-input name="address" class="w-full" v-model="address" placeholder="Company Address"/>

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Last Job Title</span><span style="color:red">*</span>
                        <vs-input name="lastJobTitle-name" class="w-full" v-model="lastJobTitle"  placeholder="Last Job Title" />

                    </div>
                </div>
                
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">From</span><span style="color:red">*</span>
                       <datepicker name="fromDate-name" class="w-full" v-model="fromDate" placeholder="Select Date"/>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">To</span><span style="color:red">*</span>
                        <datepicker name="toDate-name" class="w-full" v-model="toDate" placeholder="Select Date" />
                        
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Last Salary</span><span style="color:red">*</span>
                        <vs-input name="lastSalary-name" class="w-full" v-model="lastSalary" placeholder="Last Salary" />
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Superior Name</span>
                        <vs-input v-validate="'alpha_spaces|max:50'" name="superior name" class="w-full" v-model="superiorName" placeholder="Superior Name"/>
                        <span class="text-danger text-sm" v-show="errors.has('superior name')">{{ errors.first('superior name') }}</span>
                    </div>
                </div>
               <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Reason For Leaving</span><span style="color:red">*</span>
                        <vs-input name="reasonForLeaving-name" class="w-full" v-model="reasonForLeaving"  placeholder="Reason For Leaving"/>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Remarks</span>
                        <vs-input name="remarks-name" class="w-full" v-model="remarks" placeholder="Remarks" />
                    </div>
                </div>
                 
               

            
                </vx-card>
            </vs-prompt>




                 <!-- EDIT ACCREDITATION -->
            <vs-prompt
                class="email-compose"
                title="Job History"
                accept-text= "Submit"
                @accept="onEditJobHistory"
                :is-valid="validForm"
                :active.sync="activePromptEditJobHistory">
                <vx-card title="Fill-out the following information">


               <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Company Name</span><span style="color:red">*</span>
                        <vs-input v-validate="'alpha_spaces|max:50'" name="company name" class="w-full" v-model="companyName" placeholder="Company Name" />
                        <span class="text-danger text-sm" v-show="errors.has('company name')">{{ errors.first('company name') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Company Address</span><span style="color:red">*</span>
                         <vs-input name="address" class="w-full" v-model="address" placeholder="Company Address"/>

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Last Job Title</span><span style="color:red">*</span>
                        <vs-input name="lastJobTitle-name" class="w-full" v-model="lastJobTitle"  placeholder="Last Job Title" />

                    </div>
                </div>
                
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">From</span><span style="color:red">*</span>
                       <datepicker name="fromDate-name" class="w-full" v-model="fromDate" placeholder="Select Date"/>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">To</span><span style="color:red">*</span>
                        <datepicker name="toDate-name" class="w-full" v-model="toDate" placeholder="Select Date" />
                        
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Last Salary</span><span style="color:red">*</span>
                        <vs-input name="lastSalary-name" class="w-full" v-model="lastSalary" placeholder="Last Salary" />
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Superior Name</span>
                        <vs-input v-validate="'alpha_spaces|max:50'" name="superior name" class="w-full" v-model="superiorName" placeholder="Superior Name"/>
                        <span class="text-danger text-sm" v-show="errors.has('superior name')">{{ errors.first('superior name') }}</span>
                    </div>
                </div>
               <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Reason For Leaving</span><span style="color:red">*</span>
                        <vs-input name="reasonForLeaving-name" class="w-full" v-model="reasonForLeaving"  placeholder="Reason For Leaving"/>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Remarks</span>
                        <vs-input name="remarks-name" class="w-full" v-model="remarks" placeholder="Remarks" />
                    </div>
                </div>
                 
                 
            
                </vx-card>
            </vs-prompt>
        </vx-card>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data() {
        return {
            selected            : [],
            id                  : 0,
            companyName         : '',
            lastJobTitle        : '',
            address             : '',
            lastSalary          : '',
            fromDate            : null,
            toDate              : null,
            superiorName        : '',
            reasonForLeaving    : '',
            remarks             : '',
            userId              : null,

            uid                 : null,
            activePromptNewJobHistory    : false,
            activePromptEditJobHistory    : false,

            format: "d MMMM yyyy",
        }
    },
    created() {
            this.uid = this.$route.params.id
            this.employeeJobHistory = this.uid
            
    },
    computed: {
        employeeJobHistory: {
           
           get() { return this.$store.state.hrms.employeeJobHistory },
           set(value) { this.$store.dispatch('hrms/getAllJobHistory',  value )}
            
        },
        validForm(){
            return this.companyName != '' &&  this.address != ''  &&  this.lastSalary != '' && this.lastJobTitle != '' && this.reasonForLeaving != ''
                    && this.fromDate != null && this.toDate != null
        },
       
       
    },
    methods: {
        promptAddNewJobHistory() {
            this.activePromptNewJobHistory = true
        },
        onAddJobHistory() {
            this.$validator.validateAll().then(result => {
            if (result) {
                this.$vs.loading()

                const data = {
                    companyName         : this.companyName,
                    companyAddress      : this.address,
                    lastJobTitle        : this.lastJobTitle,
                    fromDate            : this.fromDate,
                    toDate              : this.toDate,
                    lastSalary          : this.lastSalary,
                    superiorName        : this.superiorName,
                    reasonforLeaving    : this.reasonForLeaving,
                    remarks             : this.remarks,
                    userId              : this.uid,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }

                this.$store.dispatch('hrms/AddJobHistory', data)
                .then((response) =>{
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Accredition Saved',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
            } else {
                // form have errors
                this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
            }
            })
        },
        onEditJobHistory() {
            this.$validator.validateAll().then(result => {
            if (result) {
                const data = {
                    id                  : this.id,
                    companyName         : this.companyName,
                    companyAddress      : this.address,
                    lastJobTitle        : this.lastJobTitle,
                    fromDate            : this.fromDate,
                    toDate              : this.toDate,
                    lastSalary          : this.lastSalary,
                    superiorName        : this.superiorName,
                    reasonforLeaving    : this.reasonForLeaving,
                    remarks             : this.remarks,
                    userId              : this.uid,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('hrms/UpdateJobHistory', data)
                    .then(response => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Success',
                            text: 'Job History Updated',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'success'                  
                            })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
                    })
                } else {
            // form have errors
                this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
            }
            })
        },
        editRecord(Id) {

            const e = this.$store.getters['hrms/employeeJobHistory'](Id)
            this.id             = e.id,
            this.companyName         = e.companyName,
            this.address             = e.companyAddress,
            this.lastJobTitle        = e.lastJobTitle,
            this.fromDate            = e.fromDate,
            this.toDate              = e.toDate,
            this.lastSalary          = e.lastSalary,
            this.superiorName        = e.superiorName,
            this.reasonForLeaving    = e.reasonforLeaving,
            this.remarks             = e.remarks,
            this.userId              = e.userId

            this.activePromptEditJobHistory = true
        },
        confirmDeleteRecord(id) {
            this.$store.dispatch('hrms/DeleteJobHistory', id)
            .then(res => {
                this.$vs.loading.close()
                        this.employeeJobHistory = this.uid
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Job History Deleted',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                   })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
        }
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        // VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>